
import { BrowserModule } from '@angular/platform-browser';
import { NgModule } from '@angular/core';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { AppComponent } from './app.component';
import { MDBBootstrapModule } from 'angular-bootstrap-md';
import { FormsModule } from '@angular/forms';
import { AppRoutingModule } from './app-routing.module';
import { RouterModule, Routes } from '@angular/router';
import { HomeComponent } from './home/home.component';
import { NavbarComponent } from './navbar/navbar.component';
import {NgParticlesModule} from 'ng-particles';
import { VerifyComponent } from './verify/verify.component';
import { AngularFireModule } from '@angular/fire';
import { AngularFireDatabaseModule } from '@angular/fire/database';
import { environment } from '../environments/environment';
import { NavbarSmallComponent } from './navbar-small/navbar-small.component';
import { ViewPulsarSignalsComponent } from './view-pulsar-signals/view-pulsar-signals.component';
import { ViewPulsarNonPulsarSignalsComponent } from './view-pulsar-non-pulsar-signals/view-pulsar-non-pulsar-signals.component';
import { HelpComponent } from './help/help.component';
import { TestWithAnotherAlgorithmComponent } from './test-with-another-algorithm/test-with-another-algorithm.component';
import { HttpClientModule } from '@angular/common/http';
import { ScrollSpyDirective } from './scroll-spy.directive';
import { FooterComponent } from './footer/footer.component';

const routes: Routes = [
  { path: 'home', component: HomeComponent },
  { path: '', redirectTo: '/home', pathMatch: 'full' },
  { path: 'verify', component: VerifyComponent},
  { path: 'view_pulsar', component: ViewPulsarSignalsComponent},
  { path: 'view_pulsar_non_pulsar', component: ViewPulsarNonPulsarSignalsComponent},
  { path: 'help', component: HelpComponent},
  { path: 'test_with_another_algorithm', component: TestWithAnotherAlgorithmComponent}

];

@NgModule({
  declarations: [
    AppComponent,
    HomeComponent,
    NavbarComponent,
    VerifyComponent,
    NavbarSmallComponent,
    ViewPulsarSignalsComponent,
    ViewPulsarNonPulsarSignalsComponent,
    HelpComponent,
    TestWithAnotherAlgorithmComponent,
    ScrollSpyDirective,
    FooterComponent
  ],
  imports: [
    BrowserModule,
    BrowserAnimationsModule,
    MDBBootstrapModule.forRoot(),
    FormsModule,
    AppRoutingModule,
    RouterModule.forRoot(routes),
    NgParticlesModule,
    AngularFireModule.initializeApp(environment.firebase),
    AngularFireDatabaseModule,
    HttpClientModule,
  ],
  providers: [],
  bootstrap: [AppComponent]
})

// @ts-ignore
export class AppModule { }
